export default __webpack_public_path__ + "static/media/weDrive.7313da47.png";